<script setup lang="ts">
import type { Distance } from '../models';

import ActicityDescription from './description/ActivityDescription.vue';
import ActivityDescriptionLoader from './loaders/ActivityDescriptionLoader.vue';
import ActivityDescriptionDistances from './description/ActivityDescriptionDistances.vue';
import ActivityDescriptionDistancesLoader from './loaders/ActivityDescriptionDistancesLoader.vue';

interface ActivityDetailsDescriptionProps {
  isLoading: boolean;
  description: string | undefined;
  distances: Distance[] | undefined;
}
const props = defineProps<ActivityDetailsDescriptionProps>();
</script>

<template>
  <div class="activity-details-description">
    <ActivityDescriptionLoader v-if="props.isLoading || !props.description" />
    <ActicityDescription v-else :description="props.description" />
    <ActivityDescriptionDistancesLoader
      v-if="props.isLoading || !props.distances"
    />
    <ActivityDescriptionDistances
      v-else-if="props.distances"
      :distances="props.distances"
    />
  </div>
</template>

<style scoped lang="scss"></style>
